export enum ObsAlertTypeEnum {
    QualityIssueWithIntern = 1,
    BragAboutThisIntern = 2,
    SafetyConcern = 3,
    Miscellaneous = 4,
    LeaveResignOrTerminate = 5,
    Collaboration = 6
  }
